import React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useLocation } from "react-router-dom";
import { MERGE_ACCOUNTS_SECTION_ID, ROUTES } from "../../../../constants";
import sharedMessages from "../../../../shared-messages";
import messages from "./merge-accounts-section-messages";

import "./merge-accounts-section.scss";

const block = "merge-accounts-section";

const MergeAccountsSection = () => {
  const { search } = useLocation();

  return (
    <div className={block}>
      <h2 className={`${block}__title`} id={MERGE_ACCOUNTS_SECTION_ID}>
        <FormattedMessage {...sharedMessages.mergeAccounts} />
      </h2>
      <p className={`${block}__details`}>
        <FormattedMessage
          {...messages.mergeDatafromAccount}
          values={{
            getStartedLink: displayGetStartedLink(block, search)
          }}
        />
      </p>
    </div>
  );
};

const displayGetStartedLink = (block, search) => msg => (
  <Link
    className={`${block}__link`}
    to={{ pathname: ROUTES.MERGE_ACCOUNTS, search }}
  >
    {msg}
  </Link>
);

export default MergeAccountsSection;
